import { Button, Flex, Input, Modal, ModalBody, Typography } from '@coolblue-development/freddy';
import copyWishlistUrlTrigger from '@coolblue-development/ga4-events/triggers/Wishlist/copyWishlistUrlTrigger';
import { Checkmark, Copy } from '@coolblue-development/icons';
import { useAnalytics } from '@coolblue-development/next-analytics/client';
import { useFreddyTranslations } from '@coolblue-development/next-design-system-utils/client';
import { useTranslation } from '@i18n/useTranslation';
import { copyToClipboard } from '@utils/copyToClipboard';
import { ReactNode, useState } from 'react';

export default function ShareWishlistModal({
  shareableWishlistUrl,
  isOpen,
  setIsOpen
}: {
  shareableWishlistUrl: string;
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
}): ReactNode {
  const { t } = useTranslation('webshop.wishlist');
  const [isCopied, setIsCopied] = useState(false);
  const modalTranslations = useFreddyTranslations('modal');
  const { trackEvent } = useAnalytics();

  const handleOnCopyClick = (): void => {
    copyToClipboard(shareableWishlistUrl).then(r => {
      if (r) {
        setIsCopied(true);
        trackEvent(
          copyWishlistUrlTrigger({
            status: 'success',
            url_type: 'share',
            link_url: shareableWishlistUrl
          })
        );
        setTimeout(() => {
          setIsCopied(false);
        }, 2000);
      }
    });
  };

  return (
    <Modal
      open={isOpen}
      translations={modalTranslations}
      title={t('shareWishlist')}
      body={
        <ModalBody>
          <Typography mb={600}>{t('shareWishlistModalDescription')}</Typography>
          <Flex gap={200}>
            <Input sx={{ width: '100%' }} value={shareableWishlistUrl} />
            {isCopied ? (
              <Button
                sx={theme => ({
                  minWidth: '11rem',
                  color: theme.color.icon.sentimentPositive,
                  borderColor: theme.color.border.base,
                  boxShadow: `inset 0 -1px 0 ${theme.color.border.base}`,
                  '&:hover': { borderColor: theme.color.border.base }
                })}
                size='small'
                startIcon={<Checkmark />}
                variant='secondary'
              />
            ) : (
              <Button
                sx={{ minWidth: '11rem' }}
                size='small'
                startIcon={<Copy />}
                variant='secondary'
                onClick={handleOnCopyClick}
              >
                {t('copy')}
              </Button>
            )}
          </Flex>
        </ModalBody>
      }
      size='medium'
      onClose={() => setIsOpen(!isOpen)}
    />
  );
}
